import React from 'react';

export default function CautionFlagsModalContent() {
  return (
    <>
      <p>
        Caution flags indicate that VA or other federal agencies like the
        Department of Defense (DoD) or Department of Education (ED) have applied
        increased regulatory or legal scrutiny to this program.
      </p>
    </>
  );
}
